<template lang="html">
  <header id="header">
    <b-navbar
      toggleable="lg"
      type="light"
      variant="white"
      fixed="top"
      class="border-bottom py-1 py-lg-3"
    >
      <b-container>
        <b-navbar-brand to="/" class="d-flex align-items-center">
          <b-img src="public/images/logo.png" class="header-logo" fluid />
        </b-navbar-brand>

        <b-navbar-toggle target="home2-nav-collapse" aria-label="Abrir menú" />

        <b-collapse id="home2-nav-collapse" is-nav v-model="isMenuOpen">
          <b-form class="my-3 my-md-0 mx-md-4 flex-grow-1" inline @submit.prevent="onSearch">
            <b-input-group class="w-100 header-search-group">
              <b-input-group-prepend>
                <b-input-group-text class="bg-white">
                  <i class="fa-solid fa-magnifying-glass txt-cprimary"></i>
                </b-input-group-text>
              </b-input-group-prepend>

              <b-form-input
                v-model.trim="searchQuery"
                type="text"
                minlength="3"
                placeholder="Buscar"
                aria-label="Buscar"
              />

              <b-input-group-append>
                <b-button class="btn-bg-primary btn-search" type="submit">Buscar</b-button>
              </b-input-group-append>

              <div class="box-autocomplete" v-if="showAutocomplete">
                <div class="box-autocomplete-results">
                  <router-link class="box-a-product" v-for="(p, pInx) in productsResults" :key="'pInx-'+pInx" :to="'/producto/'+$root._converToURL(p.name, p.id)">
                    <div class="col-lg col-image">
                      <img class="placed-backg" src="public/images/pages/products/product.png" v-bind:style="{ backgroundImage: 'url('+p.image+')' }">
                    </div>

                    <div class="col-lg col-info">
                      <h6 class="name">{{ p.name }}</h6>
                      <p class="price">
                        <span v-if="p.price_offer">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.price_offer) }} USD</span>
                        <span class="old-price" v-if="p.price_offer">{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.price) }} USD</span>
                        <span v-else>{{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.price) }} USD</span>
                      </p>
                    </div>
                  </router-link>
                </div>

                <a class="close-autocomplete t-150" @click="hideAutocomplete"><i class="fa-solid fa-xmark"></i></a>
              </div>
              <div class="box-autocomplete-hover" v-if="showAutocomplete" @click="hideAutocomplete"></div>
            </b-input-group>
          </b-form>

          <b-navbar-nav class="ml-auto align-items-md-center">
            <!-- <template v-for="item in navItems">
              <b-nav-item-dropdown
                v-if="item.submenu"
                :key="item.name + '-dropdown'"
                :text="item.name"
                right
                toggle-class="nav-link"
                menu-class="p-0 header-dropdown-menu"
                v-model="isSubmenuOpen"
                @show="onSubmenuShow"
                @hide="onSubmenuHide"
              >
                <div class="p-3 border-bottom">
                  <p class="mb-0 text-muted small font-weight-medium">
                    Ofrecemos soluciones tecnológicas especializadas para diferentes industrias.
                  </p>
                </div>

                <b-dropdown-item
                  v-for="sub in item.submenu"
                  :key="sub.name"
                  :to="sub.href"
                  class="py-3"
                  @click="closeAll"
                >
                  <div class="d-flex box-opt">
                    <div class="mr-3 header-submenu-icon">
                      <i :class="sub.iconClass" class="txt-cprimary"></i>
                    </div>
                    <div class="b-txt">
                      <div class="font-weight-bold">{{ sub.name }}</div>
                      <div class="txt small text-muted">{{ sub.description }}</div>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item
                v-else
                :key="item.name + '-link'"
                :to="item.href"
                :class="{ 'font-weight-bold': item.isStrong }"
                @click="closeAll"
              >
                {{ item.name }}
              </b-nav-item>
            </template> -->

            <template>
              <b-nav-item :class="{ 'nav-active' : $route.name == 'productDescriptionPage' }" to="/productos?cat&page=1" @click="closeAll">Productos</b-nav-item>
              <b-nav-item :class="{ 'nav-active' : $route.name == 'dronDescriptionPage' }" to="/drones?page=1" @click="closeAll">Drones</b-nav-item>
              <li class="nav-item b-nav-dropdown dropdown">
                <a class="nav-link dropdown-toggle nav-link" :class="{ 'f-w-700' : ($route.name == 'familyProductsPage' || $route.name == 'familyDescriptionPage') }" @click="$refs['modal-families'].show();"><span>Soluciones Tech</span><b class="caret"></b></a>
              </li>
              <b-nav-item to="/distribuidores" @click="closeAll">Distribuidores</b-nav-item>
            </template>

            <b-nav-item class="ml-md-2">
              <b-button to="/soporte" variant="dark" size="sm" class="my-2 my-md-0" @click="closeAll">
                Soporte
              </b-button>
            </b-nav-item>

            <b-nav-item to="/login" class="ml-md-2" aria-label="Login" @click="closeAll">
              <i class="fa-regular fa-user"></i> <span class="d-lg-none">Login</span>
            </b-nav-item>

            <b-nav-item to="/contacto" class="ml-md-2 d-lg-none d-xl-inline-block" aria-label="Contacto" @click="closeAll">
              <i class="fa-regular fa-envelope"></i> <span class="d-lg-none">Contacto</span>
            </b-nav-item>

            <b-nav-item to="/cart" class="ml-md-2" aria-label="Carrito" @click="closeAll">
              <i class="fa-regular fa-shopping-cart"></i> <span class="d-lg-none">Carrito</span>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <sweet-modal ref="modalAlert" :icon="$root.modaldata.icon" @close="closeModalAlert" >
      <p v-html="$root.modaldata.msg"></p>
    </sweet-modal>

    <b-modal modal-class="modal-families" ref="modal-families" size="xl" scrollable hide-footer centered title="">
      <div class="row">
        <div class="col-lg-4 col-xl-3 col-item" v-for="(option, optInx) in families" :key="'optInx-'+optInx">
          <router-link class="d-flex box-opt" :to="'/soluciones-tech?fam='+option.id+'&page=1'">
            <div class="mr-3 header-submenu-icon">
              <img class="img-fluid" :src="option.image" v-if="option.image">
              <img class="img-fluid" src="public/images/shared/placeholder.svg" v-else>
              <!-- <i :class="option.iconClass" class="txt-cprimary"></i> -->
            </div>
            <div class="b-txt">
              <div class="font-weight-bold title">{{ option.name }}</div>
              <!-- <div class="txt small text-muted">{{ sub.description }}</div> -->
            </div>
          </router-link>
        </div>
      </div>
    </b-modal>
  </header>
</template>

<script>
export default {
  name: 'Home2Header',
  data() {
    return {
      // == Autocomplete ==
      showAutocomplete: false,
      productsResults: [],
      // == ===

      isMenuOpen: false,
      isSubmenuOpen: false,
      searchQuery: '',
      families: [],
      navItems: [
        { name: 'Productos', href: '/productos?cat&page=1', isStrong: true },
        { name: 'Drones', href: '/drones?page=1', isStrong: true },
        {
          name: 'Soluciones Tech',
          href: '#soluciones-tech',
          submenu: [
            {
              name: 'Seguridad',
              href: '/#seguridad',
              description: 'Sistemas de vigilancia y protección perimetral',
              iconClass: 'fa-solid fa-shield-halved',
            },
            {
              name: 'Inspección',
              href: '/#inspeccion',
              description: 'Análisis técnico de infraestructuras y equipos',
              iconClass: 'fa-solid fa-magnifying-glass',
            },

          ],
        },
        { name: 'Distribuidores', href: '/distribuidores', isStrong: false },
      ],
    };
  },

  methods: {
    getFamilies() {
      axios.get(tools.url('/api/family-options')).then((response) =>{
        this.families = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (!this.isMenuOpen) this.isSubmenuOpen = false;
    },
    toggleSubmenu() {
      this.isSubmenuOpen = !this.isSubmenuOpen;
    },
    openSubmenuDesktop() {
      // En móvil preferimos toggle por click; en desktop funciona como hover.
      if (window.innerWidth >= 768) this.isSubmenuOpen = true;
    },
    closeSubmenuDesktop() {
      if (window.innerWidth >= 768) this.isSubmenuOpen = false;
    },
    onSubmenuShow() {
      this.isSubmenuOpen = true;
    },
    onSubmenuHide() {
      this.isSubmenuOpen = false;
    },
    closeAll() {
      this.isMenuOpen = false;
      this.isSubmenuOpen = false;
      this.$refs['modal-families'].hide();
    },
    onSearch() {
      // Ajusta a tu flujo real de búsqueda si ya existe.
      if (!this.searchQuery) return;
      this.$router.push({ path: '/busqueda', query: { k: this.searchQuery, page: 1 } });
      this.closeAll();
    },

    closeModalAlert() {
      this.$root.modaldata.show = false;
    },

    hideAutocomplete() {
      this.productsResults = [];
      this.showAutocomplete = false;
    },
  },

  watch: {
    '$root.modaldata.show':function(val){
        if(val == true){
          this.$refs.modalAlert.open();
        }
    },

    'searchQuery' (val, oldVal) {
      this.productsResults = [];
      this.showAutocomplete = false;

      if (val.length > 2) {
        axios.post(tools.url('/api/products/autocomplete'),{ keywords: val }).then((response) =>{
          // Manejar nueva estructura de respuesta con sugerencias
          if(response.data !== undefined) {
            this.productsResults = response.data;

            if(this.productsResults.length > 0) {
              this.showAutocomplete = true;
            }
          }
        }).catch((error)=>{
          console.log(error);
        });
      }
    },

    '$route' (to, from){
      this.showAutocomplete = false;
      this.closeAll();
    }
  },

  mounted() {
    this.getFamilies();
  },
};
</script>
